<template>
  <validation-observer v-slot="{ valid }">
    <validation-helper :interceptor="valid" @isValid="$emit('thirdStepAvailable', $event)" />

    <v-row class="mx-auto">
      <v-col id="saneamento-voc-aplicar-flags" cols="12" class="pl-2 pt-0">
        <v-checkbox
          label="Aplicar Flags nas obras" 
          v-model="_campos.aplicarFlags"
        />
      </v-col>
    </v-row>

    <template v-if="_campos.aplicarFlags == true">
      <v-row id="saneamento-voc-parametrizacao-flags" class="mx-auto">  
        <v-col cols="12" class="py-1">
          <span style="color: #757575; font-size:15px;">Parametrização de Flags</span> 
        </v-col>

        <v-col cols="12" class="pb-0">
          <v-alert dense outlined type="info" color="blue" class="pa-2">
            Habilite pelo menos uma Flag
          </v-alert>

          <validation-provider rules="required" immediate>
            <input type="hidden" name="valida-selecionar-uma-flag" v-model="minOneFlagSelected">
          </validation-provider>
        </v-col>

        <v-col cols="12">
          <v-expansion-panels multiple v-model="_campos.flagsPanels" accordion>
            <v-expansion-panel 
              v-for="(flag, _key) in _campos.flags" :key="_key"
              :id="'saneamento-voc-'+_key"
            >
              <v-expansion-panel-header style="font-weight: 300; font-size: 15px;">
                {{ flag.label }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="mx-auto">
                  <v-col cols="12" sm="8">
                    <v-select
                      :items="flag.aplicacaoList"
                      v-model="flag.aplicacao"
                      label="Aplicação"
                    />
                  </v-col>
                  <v-col 
                    cols="12" sm="4"
                    v-if="flag.aplicacao != 'NAO_APLICAR'" 
                  >
                    <validation-provider v-slot="{ errors }" rules="required">
                      <v-text-field
                        label="Percentual de Falha"
                        type="number" min="0" max="1" step="0.1"
                        hint="Valor entre 0 (0%) e 1 (100%)"
                        v-model="flag.percentualFalha"
                        @blur="
                          (flag.percentualFalha > 1) ? flag.percentualFalha = 1 : 1;
                          (flag.percentualFalha < 0) ? flag.percentualFalha = 0 : 1;
                        "
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <saneamento-voc-flag-data
                  v-if="_key === 'flag_data'"
                  :aplicacao.sync="flag.aplicacao"
                  :janelaDataImob.sync="flag.janelaDataImob"
                  :periodosDataLancamento.sync="flag.periodosDataLancamento"
                  :desconsiderarItensZeradosOuNegativos.sync="flag.desconsiderarItensZeradosOuNegativos"
                  :expurgarItensRacionalizacaoCOM.sync="flag.expurgarItensRacionalizacaoCOM"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <v-row class="mx-auto">
        <v-col cols="12" class="pl-2">
          <v-checkbox 
            label="Criar lista de exceções de Obras (Flag Data e UAR <= 10%)"
            v-model="_campos.criarListaExcecaoObras" 
            hide-details class="py-0 my-0"
          />
        </v-col>
      </v-row>
      <v-row class="mx-auto" v-if="_campos.criarListaExcecaoObras">
        <v-col cols="12">
          <v-textarea
            class="pt-0 mt-0"
            label="Obras Não Aplicaveis"
            v-model="_campos.obrasNaoAplicaveis"
            placeholder="Insira os códigos das obras que devem ser ignoradas nas Flags, uma por linha. Ex.:
CI1944457111 
CI1944457348"
            rows="5"
            no-resize
            clearable
            clear-icon="mdi-close-circle"
          />
        </v-col>
      </v-row>
      <v-row class="mx-auto">
        <v-col cols="12" class="pl-2">
          <v-checkbox 
            label="Criar lista de exceções de Materiais (Flag Data)"
            v-model="_campos.criarListaExcecaoMateriais" 
            hide-details class="py-0 my-0"
          />
        </v-col>
      </v-row>

      <v-row class="mx-auto" v-if="_campos.criarListaExcecaoMateriais">
        <v-col cols="12">
          <v-textarea
            class="pt-0 mt-0"
            label="Materíais Não Aplicaveis"
            v-model="_campos.materiaisNaoAplicaveis"
            placeholder="Insira os códigos dos materiais que devem ser ignoradas nas Flags, um por linha. Ex.:
D00163497 
D00163496"
            rows="5"
            no-resize
            clearable
            clear-icon="mdi-close-circle"
          />
        </v-col>
      </v-row>
    </template>

  </validation-observer>
</template>

<script>

export default {
  name: "SaneamentoVocSecondWizardTab",

  components: {
    ValidationHelper: () => import("@/components/general/ValidationHelper.vue"),
    SaneamentoVocFlagData: () => import("@/components/saneamentoVoc/flags/SaneamentoVocFlagData.vue"),
  },

  props: {
    campos: {
      type: Object,
      required: true
    },
  },

  computed: {
    _campos: {
      get() {
        return this.campos;
      },
      set(newValues) {
        this.$emit("update:campos", newValues);
      }
    },
    minOneFlagSelected() {
      return this._campos.flags.flag_uar_zero.aplicacao != "NAO_APLICAR" || 
        this._campos.flags.flag_data.aplicacao != "NAO_APLICAR"
          ? true
          : undefined
    },
  },
}

</script>

<style>

</style>